
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'HokifyBenefits',
	props: {
		ssr: { type: Boolean }
	}
});
